import { render } from "./conversation.vue?vue&type=template&id=e4db56b4&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=e4db56b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4db56b4"]])

export default __exports__